import React, { memo } from 'react';

const TableNameAddress = memo( ( { address } ) => {
  const cell = address.split( ',' );

  return cell.map( line => <div key={ line } title={ address }>{ line }</div> );
});

export default TableNameAddress;